export const QUIZ_LINKS = {
  INSURANCE: 'https://www.nerdwallet.com/insurance/auto/car-insurance',
  CREDIT_CARD:
    'https://www.nerdwallet.com/the-best-credit-cards',
  MORTGAGE: 'https://www.nerdwallet.com/best/mortgages/mortgage-lenders',
  PERSONAL_LOAN:
    'https://www.nerdwallet.com/personal-loans',
  SMALL_BUSINESS_LOAN:
    'https://www.nerdwallet.com/small-business-loans',
  BANKING: 'https://www.nerdwallet.com/best/banking/high-yield-online-savings-accounts',
  INVESTING: 'https://nerdwallet.com/best/investing/online-brokers-for-stock-trading',
  STUDENT_LOAN:
    'https://www.nerdwallet.com/best/loans/student-loans/private-student-loans',
};

export const INSURANCE_LINKS = {
  AUTO: 'https://www.nerdwallet.com/insurance/auto/match?qsSrcId=664395',
  LIFE: 'https://www.nerdwallet.com/insurance/life/match?offer_id=796',
  PROPERTY: 'https://www.nerdwallet.com/insurance/home/match?qsSrcId=662940',
};

export const MORTGAGE_LINKS = {
  PURCHASE:
    'https://analyze.nerdwallet.com/mortgage/purchase/apply/property-type?affiliateName=NerdWallet&affiliateId=1333&subId1=organic&subId2=mortgage_refi_superbowl&subId3=homepage',
  REFINANCE:
    'https://analyze.nerdwallet.com/mortgage/refinance/apply/property-type?affiliateName=NerdWallet&affiliateId=1333&subId1=organic&subId2=mortgage_refi_superbowl&subId3=homepage',
  HOME_EQUITY_LOAN:
    'https://analyze.nerdwallet.com/home-equity?affiliateName=NerdWallet&affiliateId=1333&subId1=organic&subId2=mortgage_heloc_superbowl&subId3=homepage',
};
